/* Unapology Labs - lazy PDF sample viewer. pdf.js is fetched only when the viewer is near the screen or the visitor asks for it. */
(function () {
  'use strict';
  var libPromise = null;
  var ZOOMS = [0.6, 0.8, 1, 1.25, 1.5, 2];

  function loadPdfJs(lib, worker) {
    if (window.pdfjsLib) { window.pdfjsLib.GlobalWorkerOptions.workerSrc = worker; return Promise.resolve(window.pdfjsLib); }
    if (!libPromise) {
      libPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = lib; s.async = true;
        s.onload = function () {
          if (!window.pdfjsLib) { libPromise = null; reject(new Error('pdf.js not available')); return; }
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = worker;
          resolve(window.pdfjsLib);
        };
        s.onerror = function () { libPromise = null; reject(new Error('pdf.js failed to load')); };
        document.head.appendChild(s);
      });
    }
    return libPromise;
  }

  function Viewer(root) {
    var q = function (sel) { return root.querySelector(sel); };
    this.root = root;
    this.host = root.closest('[data-aimp-sample]') || root;
    this.src = root.getAttribute('data-src') || '';
    this.lib = root.getAttribute('data-lib');
    this.worker = root.getAttribute('data-worker');
    this.mode = root.getAttribute('data-load') || 'visible';
    this.msgLoading = root.getAttribute('data-msg-loading') || 'Loading preview...';
    this.msgError = root.getAttribute('data-msg-error') || 'The preview could not be loaded.';
    this.stage = q('[data-stage]');
    this.pagesEl = q('[data-pages]');
    this.startBtn = q('[data-start]');
    this.statusEl = q('[data-status]');
    this.fallback = q('[data-fallback]');
    this.input = q('[data-page-input]');
    this.totalEl = q('[data-total]');
    this.zoomLabel = q('[data-zoom-label]');
    this.prevBtn = q('[data-prev]');
    this.nextBtn = q('[data-next]');
    this.zoomInBtn = q('[data-zoom-in]');
    this.zoomOutBtn = q('[data-zoom-out]');
    this.end = q('[data-end]');
    this.endClose = q('[data-end-close]');
    this.pdf = null; this.total = 0; this.current = 1; this.zoomIdx = 2; this.gen = 0;
    this.queue = []; this.active = 0; this.ratios = {}; this.pageEls = []; this.started = false;
    this.pending = null; this.endDismissed = false; this.baseW = 0; this.pageW = 0;
    this.bind();
  }

  Viewer.prototype.bind = function () {
    var self = this;
    var list = this.host.querySelectorAll('[data-goto]');
    Array.prototype.forEach.call(list, function (btn) {
      btn.addEventListener('click', function () { self.goTo(parseInt(btn.getAttribute('data-goto'), 10) || 1); });
    });
    if (!this.src) { return; }
    if (this.startBtn) {
      this.startBtn.addEventListener('click', function () { self.start(); });
      ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
        self.startBtn.addEventListener(ev, function () { self.warm(); }, { once: true, passive: true });
      });
    }
    if (this.mode === 'visible' && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { io.disconnect(); self.start(); break; }
        }
      }, { rootMargin: '300px 0px' });
      io.observe(this.root);
    }
    this.prevBtn.addEventListener('click', function () { self.goTo(self.current - 1); });
    this.nextBtn.addEventListener('click', function () { self.goTo(self.current + 1); });
    this.zoomInBtn.addEventListener('click', function () { self.setZoom(self.zoomIdx + 1); });
    this.zoomOutBtn.addEventListener('click', function () { self.setZoom(self.zoomIdx - 1); });
    this.input.addEventListener('change', function () { self.goTo(parseInt(self.input.value, 10) || 1); });
  };

  Viewer.prototype.warm = function () { loadPdfJs(this.lib, this.worker).catch(function () {}); };

  Viewer.prototype.setStatus = function (text) { if (this.statusEl) { this.statusEl.textContent = text || ''; } };

  Viewer.prototype.start = function () {
    var self = this;
    if (this.started || !this.src) { return; }
    this.started = true;
    this.setStatus(this.msgLoading);
    if (this.startBtn) { this.startBtn.disabled = true; }
    loadPdfJs(this.lib, this.worker).then(function (lib) {
      return lib.getDocument({ url: self.src, disableAutoFetch: true, rangeChunkSize: 262144 }).promise;
    }).then(function (pdf) {
      return self.build(pdf);
    }).catch(function () {
      self.started = false;
      self.setStatus(self.msgError);
      if (self.startBtn) { self.startBtn.disabled = false; }
      if (self.fallback) { self.fallback.hidden = false; }
    });
  };

  Viewer.prototype.build = function (pdf) {
    var self = this;
    this.pdf = pdf;
    this.total = pdf.numPages;
    return pdf.getPage(1).then(function (p1) {
      var vp = p1.getViewport({ scale: 1 });
      var ratio = vp.width + ' / ' + vp.height;
      var frag = document.createDocumentFragment();
      for (var i = 1; i <= self.total; i++) {
        var el = document.createElement('div');
        el.className = 'aimp-pdf__page';
        el.setAttribute('data-page', i);
        el.style.aspectRatio = ratio;
        frag.appendChild(el);
        self.pageEls.push(el);
      }
      self.pagesEl.appendChild(frag);
      self.root.classList.add('is-ready');
      self.totalEl.textContent = self.total;
      self.input.max = self.total;
      self.input.disabled = false;
      self.measure();
      self.observe();
      self.bindRuntime();
      self.updateUi();
      if (self.pending) { var n = self.pending; self.pending = null; self.goTo(n, true); }
      if (self.total <= 1) { setTimeout(function () { self.checkEnd(); }, 900); }
    });
  };

  Viewer.prototype.measure = function () {
    this.baseW = Math.max(220, this.stage.clientWidth - 32);
    this.pageW = Math.round(this.baseW * ZOOMS[this.zoomIdx]);
    this.pagesEl.style.setProperty('--pw', this.pageW + 'px');
  };

  Viewer.prototype.observe = function () {
    var self = this;
    if (this.renderIO) { this.renderIO.disconnect(); }
    if (this.viewIO) { this.viewIO.disconnect(); }
    this.ratios = {};
    this.renderIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { self.queuePage(e.target); } else { self.release(e.target); }
      });
    }, { root: this.stage, rootMargin: '1400px 0px' });
    var th = [];
    for (var i = 0; i <= 10; i++) { th.push(i / 10); }
    this.viewIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { self.ratios[e.target.getAttribute('data-page')] = e.intersectionRatio; });
      self.pickCurrent();
    }, { root: this.stage, threshold: th });
    this.pageEls.forEach(function (el) { self.renderIO.observe(el); self.viewIO.observe(el); });
  };

  Viewer.prototype.pickCurrent = function () {
    var best = this.current, bestRatio = 0;
    for (var k in this.ratios) {
      if (this.ratios[k] > bestRatio) { bestRatio = this.ratios[k]; best = parseInt(k, 10); }
    }
    if (bestRatio > 0 && best !== this.current) { this.current = best; this.updateUi(); }
  };

  Viewer.prototype.queuePage = function (el) {
    if (el._state) { return; }
    el._state = 'queued';
    this.queue.push(el);
    this.pump();
  };

  Viewer.prototype.pump = function () {
    var self = this;
    while (this.active < 2 && this.queue.length) {
      var el = this.queue.shift();
      if (el._state !== 'queued') { continue; }
      this.active++;
      var done = function () { self.active--; self.pump(); };
      this.draw(el).then(done, done);
    }
  };

  Viewer.prototype.draw = function (el) {
    var self = this, gen = this.gen, n = parseInt(el.getAttribute('data-page'), 10);
    var tok = el._tok = (el._tok || 0) + 1;
    var alive = function () { return el._tok === tok && el._state === 'rendering' && gen === self.gen; };
    el._state = 'rendering';
    return this.pdf.getPage(n).then(function (page) {
      if (!alive()) { return; }
      var v1 = page.getViewport({ scale: 1 });
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var vp = page.getViewport({ scale: (self.pageW / v1.width) * dpr });
      var canvas = document.createElement('canvas');
      canvas.width = Math.floor(vp.width);
      canvas.height = Math.floor(vp.height);
      el.style.aspectRatio = v1.width + ' / ' + v1.height;
      var task = page.render({ canvasContext: canvas.getContext('2d', { alpha: false }), viewport: vp });
      el._task = task;
      return task.promise.then(function () {
        if (alive()) { el.appendChild(canvas); el._state = 'done'; el._task = null; }
        page.cleanup();
      });
    }).catch(function () {
      if (el._tok === tok && el._state === 'rendering') { el._state = null; }
    });
  };

  Viewer.prototype.release = function (el) {
    if (!el._state) { return; }
    el._tok = (el._tok || 0) + 1;
    if (el._task) { try { el._task.cancel(); } catch (e) {} el._task = null; }
    el._state = null;
    var c = el.querySelector('canvas');
    if (c) { c.width = 0; c.height = 0; c.remove(); }
  };

  Viewer.prototype.relayout = function () {
    var self = this, cur = this.current;
    this.gen++;
    this.queue.length = 0;
    this.pageEls.forEach(function (el) { self.release(el); });
    this.measure();
    this.observe();
    this.goTo(cur, true);
  };

  Viewer.prototype.setZoom = function (idx) {
    idx = Math.max(0, Math.min(ZOOMS.length - 1, idx));
    if (!this.pdf || idx === this.zoomIdx) { return; }
    this.zoomIdx = idx;
    this.zoomLabel.textContent = Math.round(ZOOMS[idx] * 100) + '%';
    this.relayout();
    this.updateUi();
  };

  Viewer.prototype.goTo = function (n, instant) {
    n = Math.max(1, Math.min(this.total || 1, Math.round(n) || 1));
    if (!this.pdf) { this.pending = n; this.start(); return; }
    var el = this.pageEls[n - 1];
    var top = el.offsetTop - 12;
    var far = Math.abs(top - this.stage.scrollTop) > this.stage.clientHeight * 3;
    this.stage.scrollTo({ top: top, behavior: (instant || far) ? 'auto' : 'smooth' });
    this.current = n;
    this.updateUi();
  };

  Viewer.prototype.updateUi = function () {
    this.input.value = this.current;
    this.prevBtn.disabled = !this.pdf || this.current <= 1;
    this.nextBtn.disabled = !this.pdf || this.current >= this.total;
    this.zoomOutBtn.disabled = !this.pdf || this.zoomIdx <= 0;
    this.zoomInBtn.disabled = !this.pdf || this.zoomIdx >= ZOOMS.length - 1;
    var btns = this.host.querySelectorAll('[data-goto]'), active = null, i;
    for (i = 0; i < btns.length; i++) {
      if ((parseInt(btns[i].getAttribute('data-goto'), 10) || 1) <= this.current) { active = btns[i]; }
    }
    for (i = 0; i < btns.length; i++) { btns[i].classList.toggle('is-active', btns[i] === active); }
  };

  Viewer.prototype.showEnd = function (open) {
    if (!this.end) { return; }
    this.end.classList.toggle('is-open', open);
    this.end.setAttribute('aria-hidden', open ? 'false' : 'true');
    this.end.inert = !open;
  };

  Viewer.prototype.checkEnd = function () {
    var s = this.stage, left = s.scrollHeight - s.clientHeight - s.scrollTop;
    if (left < 48) { if (!this.endDismissed) { this.showEnd(true); } }
    else if (left > 320) { this.endDismissed = false; this.showEnd(false); }
  };

  Viewer.prototype.bindRuntime = function () {
    var self = this, ticking = false, timer;
    this.stage.addEventListener('scroll', function () {
      if (ticking) { return; }
      ticking = true;
      requestAnimationFrame(function () { ticking = false; self.checkEnd(); });
    }, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (Math.abs(Math.max(220, self.stage.clientWidth - 32) - self.baseW) > 4) { self.relayout(); }
        }, 150);
      }).observe(this.stage);
    }
    if (this.endClose) {
      this.endClose.addEventListener('click', function () { self.endDismissed = true; self.showEnd(false); });
    }
  };

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-aimp-pdf]');
    Array.prototype.forEach.call(nodes, function (root) {
      if (root._aimp) { return; }
      root._aimp = new Viewer(root);
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
